import { DbMaalerType } from "../model/db-maaler-type";
import { DbTaellevaerkType } from "../model/db-taellevaerk-type";
import { MaalerType } from "../model/maaler-type.model";
import { TaellevaerkType } from "../model/taellevaerk-type.model";

export class MaalerTypeDbMapper {
    public static dbToMaalerTyper(data: DbMaalerType[]): MaalerType[] {
        return data.map((d: DbMaalerType) => this.dbToMaalerType(d));
    }

    private static dbToMaalerType(data: DbMaalerType): MaalerType {
        const result: MaalerType = {
            id: data.EMAALTYPE,
            tekst: data.EMAALTYPETEKST,
            fabrikat: data.FABRIKAT,
            taellevaerker: data.TAELLEVAERKER.map(this.dbToTaellevaerk),
            passiv: data.PASSIV
        };
        return result;
    }

    private static dbToTaellevaerk(data: DbTaellevaerkType): TaellevaerkType {
        const beskrivelse = (data.BESKRIV === "<beskrivelse>" ? "" : data.BESKRIV) || data.ENHED_TEXT;
        const result: TaellevaerkType = {
            enhedType: data.INDEXNAVN,
            beskrivelse,
            enhed: data.ENHED_TEXT,
            decimaler: data.DECIMALER
        };
        return result;
    }
}
